import { SetStateAction, useContext, useEffect, useState } from "react";
import { MenuItem, Select,Toolbar, Typography } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { getCabecalhosEficiencia } from "../../../Componentes_modulo/getCabecalhosGrupoHomoEficiencia";
import { IGrupos_Homo_Eficiencia_Alimentar } from "../../../Interfaces/eficiencia_alimentar/plano_de_alimentacao";

interface CabecalhoForm_prop {
    setIsLoading: React.Dispatch<SetStateAction<boolean>>;
    set_especie_ou_lote_homegenio_selecionada: React.Dispatch<SetStateAction<IGrupos_Homo_Eficiencia_Alimentar | undefined>>;
    especie_ou_lote_homegenio_selecionada: IGrupos_Homo_Eficiencia_Alimentar | undefined;
}

export const CabecalhoForm: React.FC<CabecalhoForm_prop> = ({
    especie_ou_lote_homegenio_selecionada
    , set_especie_ou_lote_homegenio_selecionada,
    setIsLoading }) => {
    const auth = useContext(AuthContext);

    const location = useLocation();

    const [especie_ou_lote_homegenio_lista, set_especie_ou_lote_homegenio_lista] = useState<IGrupos_Homo_Eficiencia_Alimentar[]>([]);

    const handle_change_zona_homogenea = (zona_homogenea_selecionada: number) => {
        let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista.find((el: IGrupos_Homo_Eficiencia_Alimentar) => el.id_grupo === zona_homogenea_selecionada)
        set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
    }



    useEffect(() => {
        (async () => {
            const lista = await getCabecalhosEficiencia( location.state.id_identificacao, auth.token.cookie_token);
            set_especie_ou_lote_homegenio_lista(lista)
            set_especie_ou_lote_homegenio_selecionada(lista[0])
            setIsLoading(false)
        })();
    }, []);

    return (
        <Toolbar
            style={{
                background: "#f2d1c2",
                color: "#0000000",
                justifyContent: "center",
                fontFamily: "candara",
                fontSize: 18,
                fontWeight: 500,
                display: "flex",
            }}
        >

            Grupo Homogéneo
            <Select
                value={especie_ou_lote_homegenio_selecionada?.id_grupo === undefined ? '' : especie_ou_lote_homegenio_selecionada?.id_grupo}
                label={''}
                name={'zona_homogenea'}
                sx={{
                    fontSize: 14,
                    fontFamily: "verdana",
                    minWidth: 200,
                }}
                onChange={(e) => handle_change_zona_homogenea(Number(e.target.value))}
            >

                {especie_ou_lote_homegenio_lista.map((item: IGrupos_Homo_Eficiencia_Alimentar, key) => {

                    return (
                        <MenuItem key={key} value={item.id_grupo}>
                            <Typography
                                style={{
                                    fontSize: 14,
                                    fontFamily: "candara",
                                }}
                            >
                                {item.grupo_descritivo}
                            </Typography>
                        </MenuItem>
                    );
                })}
            </Select>

        </Toolbar>
    );
};
